import { Component, ComponentChildren } from 'preact'

type UnmanagedDomProps = {
    children: ComponentChildren
}

/**
 * Prevents Re-rendering, allowing external DOM manipulation
 */
export default class UnmanagedDom extends Component<UnmanagedDomProps> {
    shouldComponentUpdate = () => false

    render({ children }: UnmanagedDomProps) {
        return children
    }
}
